/*
 * Purpose: Onboarding Wizard page — first-run vault, Gmail, and platform credentials
 * Last modified: 2026-06-26 | Agent
 * Completeness: 90
 */
import { useNavigate } from 'react-router-dom';
import { SetupWizard } from '@/components/setup/SetupWizard';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Wand2 } from 'lucide-react';

export default function SetupPage() {
  const navigate = useNavigate();

  return (
    <div className="ui-page-hierarchy min-h-screen ui-surface-canvas flex flex-col">
      <header className="ui-nav ui-surface-nav shrink-0 border-b px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Wand2 className="h-6 w-6 ui-icon shrink-0" />
          <div className="min-w-0">
            <h1 className="text-base sm:text-lg font-bold truncate">Onboarding Wizard</h1>
            <p className="text-[11px] sm:text-xs text-muted-foreground hidden sm:block">
              First-run only — vault, Google Cloud, Gmail, optional LinkedIn
            </p>
          </div>
        </div>
        <Button variant="ghost" size="sm" onClick={() => navigate('/')}>
          <ArrowLeft className="h-4 w-4 mr-1" />
          Home
        </Button>
      </header>
      <main className="flex-1 overflow-auto p-4 sm:p-6">
        <SetupWizard />
      </main>
    </div>
  );
}
